const bannerFooterLogos = () => {
  const container = document.querySelector('[data-banner-footer-logos]');
  if (!container) return;

  const items = container.querySelectorAll('.banner__inner--footer-logo-item');
  if (items.length === 0) return;

  let currentIndex = 0;
  items[currentIndex].classList.add('is-visible');

  if (items.length < 2) return;

  setInterval(() => {
    items[currentIndex].classList.remove('is-visible');
    currentIndex = (currentIndex + 1) % items.length;
    items[currentIndex].classList.add('is-visible');
  }, 2000);
};

document.addEventListener('DOMContentLoaded', bannerFooterLogos);
